import  React, { useState, useRef, useEffect  } from "react";
import { Link, useLocation, useNavigate, useHistory } from "react-router-dom";
import { Icons } from "../../assest/icons";
import Header from './header';
import LoaderSpinner from '../loaderSpinner';
import { logger } from '../../utils/logger';
import SideBarMenu from './sideBarMenu';
import { getUsersWithPagination, getAdminViewedMapForPatients, getSessionsAssignedToDoctor, getUser } from '../../services/firestore';
import { isDoctor } from '../../utils/roleHelper';

function AdminDashboard() {  
 let navigate = useNavigate();
  const [adminId] = useState(JSON.parse(localStorage.getItem('UserIdAdmin')) || '');
  const [viewedSessionsByPatient, setViewedSessionsByPatient] = useState({});
  const getPatientStorageId = (patient) => patient?.user_id || patient?.id || '';
  const isPatientFullyViewed = (patient) => {
    const patientId = getPatientStorageId(patient);
    if (!patientId) return false;
    const sessionIds = Array.isArray(patient?.sessionIds) ? patient.sessionIds.filter(Boolean) : [];
    if (sessionIds.length === 0) return false;
    const viewedSessionIds = viewedSessionsByPatient[patientId] || [];
    const viewedSet = new Set(viewedSessionIds);
    return sessionIds.every((sessionId) => viewedSet.has(sessionId));
  };
  const routeChange  = (id) => {
    localStorage.setItem('adminCurrentPatientId', id);
    navigate(`/admin/patientprofile?pid=${encodeURIComponent(id)}`, {
      state: { id: id, currentPageNo: currentPage, searchString: searchText}
    });
  } 
 
  const [TotalUser, setTotalUser] = useState('');
  const location = useLocation();  
  const initialPage = location.state?.backCurrentPage || 1; 
  const searchTextPage = location.state?.searchTxt || '';  
  const [ShowLoader, setShowLoader] = useState(false);
  const [patientDataList, setPatientDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [currentPageGroup, setCurrentPageGroup] = useState(1); 
  const [perPage, setPerPage] = useState(10);  
 
  const [searchText, setSearchText] = useState( location.state?.searchTxt || ''); 
  const [CheckString, setCheckString] = useState(searchText.length >0 ? true : false);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);  
    setCheckString(e.target.value.length > 0 ? true : false)  
  };

  const handleFilterIconClick = () => {
    setSearchText(searchText); 
    fetchData(1, recordsPerPage, searchText);
  };
  const handleResetSearch = () => {
    setSearchText(''); 
    setCurrentPage(1);
    setCheckString(false);
    fetchData(currentPage, recordsPerPage, searchText);
  };

  useEffect(() => {  
    fetchData(currentPage, recordsPerPage, searchText);
  }, [currentPage, recordsPerPage, searchText]);

  const tsVal = (val) => (val ? new Date(val).getTime() || 0 : 0);

  const getDoctorPatientList = async (doctorId, page, perPage, querytxt) => {
    const sessions = await getSessionsAssignedToDoctor(doctorId);
    if (sessions.length === 0) {
      return { users: [], total_pages: 1, total_records: 0, current_page: page, per_page: perPage };
    }
    // Group sessions by user_id
    const sessionsByUser = {};
    sessions.forEach(s => {
      const uid = s.user_id;
      if (!uid) return;
      if (!sessionsByUser[uid]) sessionsByUser[uid] = [];
      sessionsByUser[uid].push(s);
    });
    const userIds = Object.keys(sessionsByUser);
    const userProfiles = await Promise.all(userIds.map(uid => getUser(uid).catch(() => null)));
    let patients = userProfiles
      .map((user, i) => {
        if (!user) return null;
        const userSessions = sessionsByUser[userIds[i]] || [];
        const latestSession = userSessions.reduce(
          (latest, s) => tsVal(s.created_at || s.created_on) > tsVal(latest.created_at || latest.created_on) ? s : latest,
          userSessions[0] || {}
        );
        const latestSessionDate = latestSession?.created_at || latestSession?.created_on || null;
        return {
          ...user,
          latestSessionDate,
          sortTimestamp: tsVal(latestSessionDate || user.created_at || user.created_on),
          hasNewAppointment: true,
          sessionIds: userSessions.map(s => s.session_id || s.id).filter(Boolean),
          appointmentsCount: userSessions.length,
        };
      })
      .filter(Boolean);
    if (querytxt && querytxt.trim()) {
      const q = querytxt.toLowerCase();
      patients = patients.filter(p =>
        p.fullName?.toLowerCase().includes(q) ||
        p.email?.toLowerCase().includes(q) ||
        p.phoneNumber?.includes(querytxt)
      );
    }
    patients.sort((a, b) => b.sortTimestamp - a.sortTimestamp);
    const totalRecords = patients.length;
    const totalPages = Math.ceil(totalRecords / perPage) || 1;
    const startIndex = (page - 1) * perPage;
    return {
      users: patients.slice(startIndex, startIndex + perPage),
      total_pages: totalPages,
      total_records: totalRecords,
      current_page: page,
      per_page: perPage,
    };
  };

  const fetchData = async (page, perPage, querytxt) => {
    setShowLoader(true)
    try {
      const result = isDoctor()
        ? await getDoctorPatientList(adminId, page, perPage, querytxt)
        : await getUsersWithPagination(page, perPage, querytxt);
      const sortedUsers = [...(result.users || [])].sort((a, b) => {
        const aTs = new Date(a.latestSessionDate || a.created_at || a.created_on || 0).getTime();
        const bTs = new Date(b.latestSessionDate || b.created_at || b.created_on || 0).getTime();
        return bTs - aTs;
      });

      setPatientDataList(sortedUsers);
      const patientIds = sortedUsers.map((patient) => getPatientStorageId(patient)).filter(Boolean);
      const viewedMap = await getAdminViewedMapForPatients(patientIds, adminId);
      setViewedSessionsByPatient(viewedMap);
      setTotalPages(result.total_pages);
      setTotalRecords(result.total_records);
      setShowLoader(false)

    } catch (error) {
      logger.error('Error fetching data:', error);
      setShowLoader(false)
    }
  };

  const handlePageChange = (page) => { 
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };
 
  const handlePrevGroup = () => {
    if (currentPageGroup > 1) {
      setCurrentPageGroup(currentPageGroup - 1);
      setCurrentPage((currentPageGroup - 2) * 3 + 1);
    }
  };

  const handleNextGroup = () => { 
    const maxGroup = Math.ceil(totalPages / 3);
    if (currentPageGroup < maxGroup) {
      setCurrentPageGroup(currentPageGroup + 1);
      setCurrentPage(currentPageGroup * 3 + 1); 
    }
  };
 
   // Function to get the first and last characters
   const getFirstAndLastChars = (str) => {
      if (!str) return '';
      const words = str.split(' ');
      if (words.length === 0) return '';
    
      const firstChar = words[0].charAt(0).toUpperCase();
      const lastChar = words[words.length - 1].charAt(0).toUpperCase();
    
      return `${firstChar}${lastChar}`;
  };
  
  const renderTableBody = () => {
    if (!patientDataList || patientDataList.length === 0) {
      return (
        <tr>
          <td colSpan="4" style={{ textAlign: 'center' }}>No data found</td>
        </tr>
      );
    }
  
    return patientDataList.map((patient, index) => {
      const patientId = getPatientStorageId(patient);
      const allAppointmentsViewed = isPatientFullyViewed(patient);
      const rowStateClass = allAppointmentsViewed ? 'row-opened' : 'row-unopened';

      return (
      <tr
        key={index}
        onClick={() => routeChange(patientId)}
        style={{
          cursor: 'pointer',
          backgroundColor: allAppointmentsViewed ? '#ffffff' : '#c4ccd8',
          color: allAppointmentsViewed ? '#000000' : 'inherit',
        }}
        className={rowStateClass}
      >
        <td>
          <span className="d-flex align-items-center patientFullnameTxt">
            <b className="userImgIconCircleDiv"> 
              {getFirstAndLastChars(patient.fullName)}
              {/* {patient.fullName.split(' ').map(word => word.charAt(0).toUpperCase()).join('')} */}
            </b>
            <span className="fullnameTxt">{patient.fullName}</span>
          </span>
        </td>
        <td>{patient.email}</td>
        <td>{patient.phoneNumber 
    ?  patient.phoneNumber.slice(0, -2).replace(/\d/g, 'X') + patient.phoneNumber.slice(-2) 
    : '-'}</td>
        <td><span className="InsuranceIDEllipsis">{patient.insurance ? patient.insurance : '-'}</span></td>
      </tr>
    )});
  };
 
  const renderPagination = () => {
    if (!patientDataList || patientDataList.length === 0) {
      return null; // Return null to hide the pagination when there is no data
    }
  
    let pages = [];
    const startPage = (Math.floor((currentPage - 1) / 3) * 3) + 1;
    const endPage = Math.min(startPage + 2, totalPages);
  
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`page-button ${i === currentPage ? 'active' : ''}`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }
  
    return (
      <div className="pagination">
        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          Previous
        </button>
        {pages}
        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    );
  };
  
 
useEffect(() => { 
setShowLoader(true) 
}, []);



  return (
    <div>
     {ShowLoader && <LoaderSpinner />} 
      <div className='container-fluid p-0 adminDashboardMain'>
        <SideBarMenu/>
      
        <div className='container-fluid p-0 contentBody'>
             <Header />
             <div className="innerBodyBox bgInnerDiv patientDataListMain">

              <div className="contentInnerBody">
                <div className="titleDiv">
                  <h2>All Appointments</h2>
                 

                 <div className="">
                      <div  className="leftDiv d-inline-block searchAdminUser">
                              <div className="inputDivBox">
                                <img src={Icons[0].admin_searchIcon} alt="search-icon" />
                                <input
                                  type="text"
                                  placeholder="Search patient name, email, phone"
                                  value={searchText}
                                  onChange={handleSearchChange}
                                />
                               <img
                                 className={"reset-button " + (CheckString ? 'b':'d-none')}
                                  src={Icons[0].admin_deleteIcon}
                                  alt="filter-icon"
                                  onClick={handleResetSearch}
                                  style={{ cursor: 'pointer' }}
                                />
                            </div>
                      </div>
                      <ul className="titleRightSideDiv">
                        <li>Total Patients: {!totalRecords ? '0' : totalRecords}</li>
                        <li>   
                            <div className="table-options">
                              <label htmlFor="recordsPerPage">Showing</label>
                              <select id="recordsPerPage"
                               value={recordsPerPage} onChange={(e) => setRecordsPerPage(Number(e.target.value))}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select> 
                            </div>
                          </li> 
                      </ul>
                  </div>

                </div>
                <div className="contentMainBox"> 
                        <div className="table-container">
                          <table id="patientTable">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Insurance ID</th>
                              </tr>
                            </thead>
                            <tbody>
                              {renderTableBody()}
                            </tbody>
                          </table>
                        </div>
                        <div className="paginationMain">
                             {renderPagination()}
                             <span className={"totalPageDiv "+ (!totalPages ? 'd-none' : '')}>Total Pages: {totalPages}</span>
                        </div>
                </div>
              </div>
                 
             </div>
        </div> 
      </div>
    </div>
  );
}

export default AdminDashboard;
